<template>
  <div>
    <!-- 管道气 -->
    <div v-if="listingDetail.materialCode == PNGmaterialCode" class="card commodity-info">
      <div class="info van-hairline--top">
        <div class="info-header">产品信息</div>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">产品名称：</span>
            <span class="info-value">{{listingDetail.commodityName}}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">管线：</span>
            <span class="info-value">{{listingDetail.pipelineName}}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">场站：</span>
            <span class="info-value">{{stations}}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">订单量：</span>
            <span
              v-if="listingDetail.materialCode == PNGmaterialCode"
              class="info-value"
            >{{orderWeight}} 万方</span>
            <span
              v-if="listingDetail.materialCode == LNGmaterialCode"
              class="info-value"
            >{{orderWeight}} 吨</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">单 价：</span>
            <span
              v-if="listingDetail.materialCode == PNGmaterialCode"
              class="info-value"
            >{{listingDetail.price}} 元/万方</span>
            <span
              v-if="listingDetail.materialCode == LNGmaterialCode"
              class="info-value"
            >{{listingDetail.price}} 元/吨</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">订单总价：</span>
          <span class="info-value">{{sumMoney}} 元</span>
        </van-row>
      </div>
    </div>
    <!-- LNG -->
    <div v-if="listingDetail.materialCode == LNGmaterialCode" class="card commodity-info">
      <div class="info van-hairline--top">
        <div class="info-header">商品详情</div>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">产品名称：</span>
            <span class="info-value">{{listingDetail.commodityName}}</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">接收站/液化场 ：</span>
            <span class="info-value">{{listingDetail.stationName}}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">订 单 量 ：</span>
            <span class="info-value">{{orderWeight}} 吨</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">单 价：</span>
            <span class="info-value">{{$utils.amount(listingDetail.price, 2)}} 元/ 吨</span>
          </van-col>
        </van-row>
      </div>

      <!-- <div class="card commodity-info">
      <div class="info van-hairline--top">
        <div class="info-header">商品详情</div>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">产品名称：</span>
            <span class="info-value">{{listingDetail.commodityName}}</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">产品编码：</span>
            <span class="info-value">{{listingDetail.materialCode}}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">属性描述：</span>
            <span class="info-value">XXXXX</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">销售公司：</span>
            <span class="info-value">山东分公司</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">接 收 站 ：</span>
            <span class="info-value">大连接收站</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">单 价：</span>
            <span class="info-value">3,500.00 元/ 吨</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">订 单 量 ：</span>
          <span class="info-value">300 吨</span>
        </van-row>
      </div>
      <div class="info van-hairline--top">
        <van-row class="info-line">
          <span class="info-title">优 惠 1 ：</span>
          <span class="info-value">运费补贴 100.00 元/吨</span>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">优 惠 2 ：</span>
          <span class="info-value">会员折扣 200.00 元/吨</span>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">总 优 惠 ：</span>
          <span class="info-value">300.00 元/吨</span>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">优惠后单价：</span>
          <span class="info-value">3,200.00 元/吨</span>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">订单总量：</span>
          <span class="info-value">300吨</span>
        </van-row>
        <van-row class="info-line">
          <span class="info-title">订单总价：</span>
          <span class="info-value">960,000.00 元</span>
        </van-row>
      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderCommodityCard",
  props: {
    listingDetail: Object,
    stations: String,
    orderWeight: Number,
    sumMoney: String,
  },
  data() {
    return {
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
    };
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;
    }
  }
}
</style>